module.exports = __webpack_public_path__ + "img/user.9603e676.png";